
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SetService, HttpService, JwtService, PageService } from 'ngx-block-core';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-table-form-select',
  templateUrl: './table-form-select.component.html',
  styleUrls: ['./table-form-select.component.less']
})
export class TableFormSelectComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() ColumnData;
  sets;
  nzFormGroupData;
  @Input() blockid = "";
  @Input() formId = "";
  @Input() columnName = "";
  @Input() index = 0;
  constructor(
    private setService: SetService,
    private jwtService: JwtService,
    private pageService: PageService,
    private http: HttpService) { }

  nzData = [];
  ngOnInit() {
    this.sets = this.ColumnData['nzBlockSets'];
    this.nzFormGroupData = this.ColumnData['nzFormGroupData'];
    this.nzData = [...this.sets.datas.nzData]
    if (this.sets.datas.nzDynamicData) {
      this.nzData = [];
      this.loadMore();
    }
    //监听
    let control_name = this.nzFormGroupData.nzKey;
    this.form.get(control_name).valueChanges.pipe(
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(600),
    ).subscribe((val) => {
      //联动

      if (this.sets.datas.nzLinkage.nzUsed) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          this.setService.events[this.blockid + this.formId + element.blockid].emit({
            type: "linkage" + element.type,
            datas: { value: val }
          });
        });
      }

    });
    this.pzListening();
    this.Listening();
  }

  ngOnDestroy() {
    this.setService.deleteEvent(this.blockid + this.formId + this.columnName, 'pz')
    this.setService.deleteEvent(this.blockid + this.formId + this.columnName)
  }
  Listening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid + this.formId + this.columnName);
      this.setService.events[this.blockid + this.formId + this.columnName].subscribe(
        data => {
          switch (data['type']) {
            case 'linkagevalue':
              break;
            case 'linkagedatasource':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage = data['datas']['value'];

              //执行判断
              this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
              if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
              if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
              if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
              if (this.sql.indexOf("@linkage") == -1) {
                if (this.sets.datas.nzDynamicData) {
                  this.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.loadMore();
                }
              }

              break;
            case 'linkagedatasource2':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage2 = data['datas']['value'];

              //执行判断
              this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
              if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
              if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
              if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
              if (this.sql.indexOf("@linkage") == -1) {
                if (this.sets.datas.nzDynamicData) {
                  this.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.loadMore();
                }
              }

              break;
            case 'linkagedatasource3':
              console.log("linkagedatasource", data['datas']['value'])

              this.linkValue.linkage3 = data['datas']['value'];

              //执行判断
              this.sql = this.sets.datas.nzLinkageData.nzDynamicSql;
              if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) this.sql = this.sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
              if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) this.sql = this.sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
              if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) this.sql = this.sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
              if (this.sql.indexOf("@linkage") == -1) {
                if (this.sets.datas.nzDynamicData) {
                  this.nzData = [];
                  this.isLastPage = false;
                  this.nzNowPage = 0;
                  this.loadMore();
                }
              }

              break;

            default:
              break;
          }

        }
      )
    }, 100);

  }


  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid + this.formId + this.columnName, 'pz');
      this.setService.pzEvents[this.blockid + this.formId + this.columnName].subscribe(

        data => {
          switch (data['type']) {
            case 'nzDynamicDatatrue':

              break;
            case 'nzDynamicDatafalse':
              this.nzData = [];
              this.sets.datas.nzDynamicSearch.nzPaging = false;
              break;
            case 'nzPagingfalse':
              this.sets.datas.nzDynamicSearch.nzPageSize = 0;
              break;
            case 'refresh':
              this.nzData = [];
              this.isLastPage = false;
              this.nzNowPage = 0;
              this.loadMore();
              break;
            case 'savadefault':
              this.nzFormGroupData['nzValue']['nzValue'] = this.form.get(this.nzFormGroupData['nzKey']).value;
              console.log("nzFormGroupData", JSON.stringify(this.nzFormGroupData))
              break;

            default:
              break;
          }
        }
      )
    }, 100);

  }

  setnone = false
  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  sql = "";

  valueLabel = {};
  isLoading = false;
  isLastPage = false;
  nzNowPage = 0;
  searchvalue = ""
  isFirstInitSelected = true;
  initSelected() {
    let sql = this.sets.datas.nzDynamicSearch.nzDynamicSql;
    console.log("initSelectedsql:" + sql);
    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);
    console.log("数据表sql2:" + this.sets.datas.nzDynamicSearch.nzDynamicSql);
    console.log("数据表sq2:" + sql);
    if (sql.indexOf("@linkage") == -1) {
      let body = {
        "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.blockid),
        "pageSize": this.sets.datas.nzDynamicSearch.nzPaging ? this.sets.datas.nzDynamicSearch.nzPageSize : "0",
        "nowPage": this.nzNowPage,
        "paramMap": [

        ],
        "tableSort": [],
        "searchMap": {}
      }

      if (this.sets.datas.nzDynamicSearch.nzPaging) {
        const value = this.form.get(this.nzFormGroupData.nzKey).value;
        if (this.isFirstInitSelected && value != "" && value != null) {
          this.searchvalue = value;
        }
        this.isFirstInitSelected = false;
        if (this.searchvalue != "") {
          body['searchMap'][this.sets.datas.nzDynamicSearch.nzValueName] = [
            {
              "name": "like",
              "value1": this.searchvalue
            }
          ]
        }
      }
      console.log("选项body:" + JSON.stringify(body));
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          this.isLoading = false;
          if (data.data.pages >= this.nzNowPage || !this.sets.datas.nzDynamicSearch.nzPaging) {
            if (data.data.isLastPage === true) this.isLastPage = true;
            const value = this.form.get(this.nzFormGroupData.nzKey).value;
            console.log("value", this.searchvalue, value, this.sets.datas.nzSaveEmpty, "选项:" + JSON.stringify(data));
            if (this.nzNowPage > 1) {
              this.nzData = [...this.nzData, ...data.data.list];
            } else {
              this.setnone = false;
              this.nzData = [...data.data.list];
            }

            let flag = false;
            this.nzData.forEach(element => {
              if (element.VALUE == value) flag = true;
              this.valueLabel[element.VALUE] = element.LABEL;
            });
            if (this.nzData.length > 0) {
              if (value == "" || value == null) {
                // if (!this.sets.datas.nzSaveEmpty)
                this.form.get(this.nzFormGroupData.nzKey).patchValue(this.nzData[0].VALUE)
              }
              else {

                if (!flag) this.form.get(this.nzFormGroupData.nzKey).patchValue(this.nzData[0].VALUE);
                else
                  this.pageService.pageBlockDatas[this.blockid+ this.formId + this.columnName] = {
                    value: {
                      label_value: this.valueLabel[value],
                    }
                  }
              }
            } else {
              this.addNone();
            }
          }else {
            if (data.data.pages == 0) {
              this.addNone();
            }
          }




        });
    }


    else {
      this.addNone();
      this.isLoading = false;
    }

  }
  addNone() {
    console.log("选项value-加无", this.sets.datas.nzData);

    // this.setnone = true;
    // this.nzData.push({
    //   VALUE: "",
    //   LABEL: "无"
    // })
    this.form.get(this.nzFormGroupData.nzKey).patchValue(null);
    this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
    this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
    this.pageService.pageBlockDatas[this.blockid+ this.formId + this.columnName] = {
      value: {
        label_value: "",
      }
    }
  }
  loadMore() {
    if (!this.isLastPage) {
      this.isLoading = true;
      this.nzNowPage = this.nzNowPage + 1;
      this.initSelected();
    }
  }
  /** 是否做过搜索 */
  isDoSearch = false
  search(event) {
    console.log("选项，search", event)
    if (event != "" && event != null) {
      this.searchvalue = event;
      this.isDoSearch = true;
      this.isLastPage = false;
      this.nzNowPage = 0;
      this.nzData = [];
      this.loadMore();
    }

  }









}
